import { Link } from 'react-router-dom';

const steps = [
  {
    step: '01',
    icon: 'ri-download-cloud-2-line',
    title: '下载哔咔',
    description: '访问官网或应用商店，下载哔咔漫画APP。支持安卓和iOS平台，安装过程简单快捷。',
    link: '/category/xiazai-jiaocheng',
    linkText: '下载教程',
  },
  {
    step: '02',
    icon: 'ri-user-add-line',
    title: '注册账号',
    description: '使用手机号或邮箱快速注册，支持微信/QQ一键登录，注册后即可同步阅读记录。',
    link: '/category/zhuce-zhinan',
    linkText: '注册指南',
  },
  {
    step: '03',
    icon: 'ri-book-open-line',
    title: '畅享阅读',
    description: '海量正版漫画随心看，智能推荐帮你发现更多好作品，多种阅读模式自由切换。',
    link: '/category/gongneng-tese',
    linkText: '功能介绍',
  },
];

const QuickStartSection = () => {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            快速上手指南
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            只需三步，轻松开启你的哔咔漫画阅读之旅
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {steps.map((item, index) => (
            <div
              key={index}
              className="relative bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8 text-center group hover:border-primary-200/70 transition-all duration-300"
            >
              <div className="text-5xl font-heading text-primary-100 mb-4 group-hover:text-primary-200 transition-colors">
                {item.step}
              </div>
              <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-primary-100/70 flex items-center justify-center">
                <i className={`${item.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-lg font-heading text-foreground-950 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                {item.description}
              </p>
              <Link
                to={item.link}
                className="inline-flex items-center space-x-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
              >
                <span>{item.linkText}</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuickStartSection;